/* Ciralu · product gallery videos: keep the video on the active slide playing (muted loop), pause the rest. */
(function () {
  function play(v) { if (!v) return; v.muted = true; v.loop = true; v.setAttribute('playsinline', ''); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function sync(root) {
    root.querySelectorAll('.product-media-container--video').forEach(function (slide) {
      var v = slide.querySelector('video'); if (!v) return;
      var hidden = slide.getAttribute('aria-hidden') === 'true' || slide.hasAttribute('hidden');
      if (hidden) { v.pause(); } else { play(v); }
    });
  }
  function init() {
    var galleries = document.querySelectorAll('[class*="media-gallery"], .product-information');
    if (!galleries.length) return;
    galleries.forEach(function (g) {
      sync(g);
      var mo = new MutationObserver(function () { sync(g); });
      mo.observe(g, { attributes: true, subtree: true, attributeFilter: ['aria-hidden', 'hidden', 'class'] });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target.querySelector('video'); if (!v) return;
          var hidden = e.target.getAttribute('aria-hidden') === 'true';
          if (e.isIntersecting && !hidden) play(v); else if (!e.isIntersecting) v.pause();
        });
      }, { threshold: 0.35 });
      document.querySelectorAll('.product-media-container--video').forEach(function (s) { io.observe(s); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
